module.exports = __webpack_public_path__ + "static/media/river-tag-icon.e8b1e6c8.svg";